import { useEffect, useCallback } from "react";
import { useVersion } from "../store/version/hooks";
import { Box, CircularProgress, Typography, useTheme } from "@mui/material";

export default function VersionTag({ textColorLight }) {
  const theme = useTheme();
  const { loadVersion, isLoaded, value } = useVersion();

  const load = useCallback(() => {
    loadVersion();
  }, [loadVersion]);

  useEffect(() => {
    load();
  }, [load]);

  const textColor = textColorLight
    ? theme.palette.common.white
    : theme.palette.text.secondary;

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height={30}
      width={1}
    >
      {isLoaded ? (
        <Typography color={textColor} variant="caption">
          Version: {value}
        </Typography>
      ) : (
        <CircularProgress disableShrink size={14} sx={{ color: textColor }} />
      )}
    </Box>
  );
}
